export enum SosOptionEnum {
    pc = 1,
    box = 2
}